module.exports = __webpack_public_path__ + "img/icon-play.a3ee6e1f.png";